module.exports = __webpack_public_path__ + "media/images/flags/16/Comoros-97b7268fa1d158c16da5c649f7058c2d.png";